import axios from "axios";
import type { Level } from ".";
import { Transport } from "./transport";

export class HttpTransport extends Transport {
  url = "";

  constructor(url: string) {
    super();
    this.url = url;
  }

  send(level: Level, message: string, meta?: Record<string, unknown>) {
    setTimeout(() => {
      axios.post(this.url, { level, message, ...meta }).catch((error) => {
        console.error(`Failed to log to ${this.url}:`, error);
      });
    });
  }
}
